// extracted by mini-css-extract-plugin
module.exports = {"text1Line":"styles_text1Line__Yxglv","ellipsis":"styles_ellipsis__Clh2n","text2AndMoreLines":"styles_text2AndMoreLines__kPjFB","tooltipTrigger":"styles_tooltipTrigger__h0K83"};